<template>
  <div :style="isExpanded ? 'flex-basis: 100%' : ''">
    <label class="checkbox is-size-7 is-flex is-align-items-center">
      <input
        type="checkbox"
        class="mr-1"
        :checked="isExpanded"
        :data-test-id="checkboxTestId"
        @change="$emit('toggle', $event.target.checked)"
      />
      <span>Extra line of text</span>
      <IconHint v-if="isExpanded" :content="HINT_TEXTS.EXTRA_LINE_OF_TEXT" />
    </label>
    <div v-if="isExpanded" class="mt-1 mb-1 pl-3 extra-text-border">
      <input
        :value="modelValue"
        type="text"
        class="input is-small text-input"
        :style="inputWidth ? `width: ${inputWidth}` : ''"
        :placeholder="placeholder"
        :data-test-id="inputTestId"
        aria-label="Extra line of text"
        @blur="$emit('update:modelValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<script setup>
  import IconHint from "../icon-hint.vue";
  import { HINT_TEXTS } from "./utils/constants";

  defineProps({
    modelValue: { type: String, default: "" },
    isExpanded: { type: Boolean, default: false },
    placeholder: { type: String, default: "e.g., (Lavandula angustifolia)" },
    inputWidth: { type: String, default: "250px" },
    checkboxTestId: { type: String, default: "" },
    inputTestId: { type: String, default: "" },
  });

  defineEmits(["update:modelValue", "toggle"]);
</script>

<style lang="scss" scoped>
  @import "~/label/css/labels/supplements/supplement_mixins";
</style>
